<script lang="ts" setup>
import { useTemplateRef } from '#imports';
import ImAudioRadar from '../msg/ImAudioRadar.vue';

withDefaults(defineProps<{ duration: number; url: string; width?: string }>(), {
  width: '140px',
});
const audioRadarRef = useTemplateRef('audio-radar');

// 切换播放状态
function togglePlay() {
  audioRadarRef.value?.toggleAudio();
}


</script>

<template>
  <div
    class="flex h-[46px] cursor-pointer items-center rounded-lg bg-[rgba(22,119,255,0.1)] px-4"
    :style="{ width }"
    @click="togglePlay"
  >
    <ImAudioRadar ref="audio-radar" :url="url" />
    <span class="ml-auto">{{ duration }}s</span>
  </div>
</template>
<style scoped></style>
